import NoAccessOverlay from '@/creditflowresearch/ui/common/components/NoAccessOverlay';
import image from '@/creditflowresearch/ui/assets/noAccess/statNoAccess.webp';
import {
  statNoAccessTitle,
  statImageCaption,
  statNoAccessFeatures,
  statNoAccessDescription,
} from './constants';

const NoAccessOverlayStats = () => (
  <NoAccessOverlay
    title={ statNoAccessTitle }
    features={ statNoAccessFeatures }
    description={ statNoAccessDescription }
    imageCaption={ statImageCaption }
    image={ image.src }
  />
);

export default NoAccessOverlayStats;
